import { render, staticRenderFns } from "./DiseaseDetailPage.vue?vue&type=template&id=a385d400"
import script from "./DiseaseDetailPage.vue?vue&type=script&lang=js"
export * from "./DiseaseDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetailPage.vue?vue&type=style&index=0&id=a385d400&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports